import { Routes } from '@angular/router';
import { ButtonPage } from './button-page/button-page';
import { ComponentLabPage } from './component-lab-page';
import { ContentCardPage } from './content-card-page/content-card-page';
import { EggCartonsPage } from './egg-cartons-page/egg-cartons-page';
import { EggCartonPage } from './egg-carton-page/egg-carton-page';

export const componentLabRoutes: Routes = [
  {
    path: '',
    component: ComponentLabPage,
  },
  {
    path: 'button',
    component: ButtonPage,
  },
  {
    path: 'content-card',
    component: ContentCardPage,
  },
  {
    path: 'egg-carton',
    component: EggCartonPage,
  },
  {
    path: 'egg-cartons',
    component: EggCartonsPage,
  },
];
